import React from 'react';
import { familiarThoughts } from '../../data/landing';
import { useSnapIndex } from '../../hooks/useSnapIndex';
import { CarouselDots } from '../CarouselDots';
const layout = ['md:col-span-3 bg-paper', 'md:col-span-3 bg-blush/60', 'md:col-span-4 bg-sage-100', 'md:col-span-2 bg-paper', 'md:col-span-6 bg-beige-200/70'];
export function FamiliarSection() {
  const {
    ref,
    index,
    scrollTo
  } = useSnapIndex<HTMLUListElement>();
  return <section className="bg-beige-100 py-12 sm:py-24" data-id="element-149" data-mp="1do4jrvrdaq00">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-150" data-mp="1ikl9gue7tcf7">
        <h2 className="text-center font-serif text-[1.9rem] text-petrol-800 sm:text-5xl" data-id="element-151" data-mp="1inhairld0h7v">¿Te resulta familiar?</h2>

        <ul ref={ref} className="no-scrollbar relative -mx-5 mt-7 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 md:mx-0 md:mt-12 md:grid md:grid-cols-6 md:gap-4 md:overflow-visible md:px-0" data-id="element-152" data-mp="1rm2zp5lc6uhm">
          {familiarThoughts.map((thought, i) => <li key={thought} className={`flex min-h-[120px] w-[78%] shrink-0 snap-center items-start gap-3 rounded-2xl rounded-bl-sm px-5 py-5 md:w-auto md:px-6 md:py-6 ${layout[i]}`} data-id="element-153" data-mp="3306si8g6ucl3" data-mpi={i}>
              <span className="font-serif text-4xl leading-none text-terra-500" aria-hidden="true" data-id="element-154" data-mp="1s3g32ycvyqbv">
                “
              </span>
              <p className="pt-1 font-serif text-xl leading-snug text-petrol-800 sm:text-2xl" data-id="element-155" data-mp="1n2tgzl3fe512">
                {thought}
                <span className="text-terra-500" aria-hidden="true" data-id="element-156" data-mp="1j5dtvvj00rdi">”</span>
              </p>
            </li>)}
        </ul>
        <CarouselDots count={familiarThoughts.length} active={index} onSelect={scrollTo} className="mt-3 md:hidden" data-id="element-157" data-mp="19dhvskgwx19a" />

        <p className="mx-auto mt-6 max-w-2xl text-center text-[15px] leading-relaxed text-ink/75 sm:mt-12 sm:text-lg" data-id="element-158" data-mp="14ddh8zzkeglp">
          <strong className="font-semibold text-petrol-800" data-id="element-159" data-mp="zgdb6p2ptdul">Kit Sexualidad Práctica</strong> fue pensado para resolver{' '}
          <strong className="font-semibold text-terra-600" data-id="element-160" data-mp="vfjjdkm5jewf">justamente esa parte del trabajo.</strong>
        </p>
      </div>
    </section>;
}